import { makeStyles } from '@lifeomic/chroma-react/styles';

const useCommonStyles = makeStyles(() => ({
  fileSystemNode: {
    '&:active': {
      background: 'none',
    },
    '&:focus-visible': {
      background: 'none',
    },
    '&:focus': {
      background: 'none',
    },
    '&:focus-within': {
      background: 'none',
    },
  },
}));

export { useCommonStyles };
